import { FC, useEffect, useRef, useState } from 'react'
import { ErrorMessage, FieldArray, useFormikContext } from 'formik'
import { DatePicker } from 'antd'
import { KTSVG } from '../../../../../../_metronic/helpers'
import { Props } from '../../../AddExperiencePage'
import { CategoryAutocompleteField } from '../fields/CategoryAutocompleteField'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../../../../setup'
import { IAuthState } from '../../../../../modules/auth'
import { Link, useHistory } from 'react-router-dom'
import { InviteePrivateAutocompleteField } from '../fields/InviteePrivateAutocompleteField'
import { BeneficiaryAutocompleteField } from '../fields/BeneficiaryAutocompleteField'
import ImageExperienceField from '../fields/ImageExperienceField'
import GalleryUploadField from '../fields/GalleryUploadField'
import { GenericModel } from '../../../models/GenericModel'
import { getHost } from '../../../../../services/teamExperienceService'
import { validateShowButtonActions } from '../utils'
import { HostsAutocompleteField } from '../fields/HostsAutocompleteField'
import { UserRole } from '../../../../../constants/roles'
import dayjs from 'dayjs'
import { useCurrencyField } from '../../../../../hooks/components/useCurrencyField'
import CityAutocompleteField from '../fields/CityAutocompleteField'
import 'react-quill/dist/quill.snow.css'
import ReactQuill from 'react-quill'
import { SubscriptionEnum } from '../../../../../modules/auth/models/SubscriptionModel'

const MAX_QUILL_CONTENT_LENGTH = 10000

const Step2: FC<Props> = ({ onNextStep, onBackStep, haveErrors, onLoad, onLoadMessage, onPause, catalogs, onSaveDraft, experience }) => {
    const formik = useFormikContext();
    const userData = useSelector<RootState>(({ auth }) => auth, shallowEqual) as IAuthState
    const history = useHistory()
    const [listHost, setListHost] = useState<any[]>([]);
    const isFinalUser = userData.user?.roles?.includes(UserRole?.FINAL_USER);
    const isPartner = userData.user?.roles?.includes(UserRole?.PARTNER);
    const isTeamMember = userData.user?.roles?.includes(UserRole?.TEAM);
    let disabledTypeHost = false;
    const getUserListHosts = async () => {
        if(formik.values.host_type === "member" || isFinalUser || isTeamMember){
            let params = {offset: 0, limit: 100};
            if(experience?.host){
                params.search = experience?.host?.email;
            }else if(isFinalUser){
                params.search = userData?.user?.email;
            }else if(isTeamMember){
                params.search = userData?.user?.actingFor?.email;
            }
            let hosts = await getHost(params);
            setListHost(hosts?.results)
            if(isFinalUser){
                formik.setFieldValue('host_id',userData?.user?.id)
                disabledTypeHost = true;
            }else if(isTeamMember){
                formik.setFieldValue('host_id',userData?.user?.actingFor?.id)
                disabledTypeHost = true;
            }
        }else{
            let params = {offset: 0, limit: 100, type: 'partner'};
            if(isPartner){
                params.search = userData?.user?.email;
            }
            let hosts = await getHost(params);
            setListHost(hosts?.results)
            if(isPartner){
                formik.setFieldValue('host_id',userData?.user?.id)
                disabledTypeHost = true;
            }
        }
    }

    useEffect(() => {
        getUserListHosts();
    }, [formik.values.host_type]);

    const handleExperienceChange = (e: any) => {
        const value = e.target.value.slice(0, 100); // límite
        formik.setFieldValue("title", value);
    };
    
    const handleDescriptionChange = (e: any) => {
        const value = e.target.value.slice(0, 100); // límite
        formik.setFieldValue("description", value);
    };

    // Cuando el input recibe focus
    const priceField = useCurrencyField({
        formik,
        fieldText: "price_per_guest_text",
        fieldNumber: "price_per_guest",
    });

    const handleCategoryChange = (value:string) => {
        formik.setFieldValue("category_ids", value);
    };
    
    const handleInviteesChange = (value:string) => {
        formik.setFieldValue("allowed_guest_ids", value);
        formik.validateForm();
    };

    /* itinerary */
    const textareaRef = useRef(null);
    const handleTextAreaInput = (e) => {
        const el = textareaRef.current;
        el.style.height = "auto"; // resetea para medir bien
        const lineHeight = 20;    // ajusta según tu font-size
        const maxHeight = 5 * lineHeight;

        el.style.height = Math.min(el.scrollHeight, maxHeight) + "px";
    };
    /* whats includes */
    const textareaRef2 = useRef(null);
    const handleTextAreaInput2 = (e) => {
        const el = textareaRef2.current;
        el.style.height = "auto"; // resetea para medir bien
        const lineHeight = 20;    // ajusta según tu font-size
        const maxHeight = 5 * lineHeight;

        el.style.height = Math.min(el.scrollHeight, maxHeight) + "px";
    };
    /* arrival notes */
    const textareaRef3 = useRef(null);
    const handleTextAreaInput3 = (e) => {
        const el = textareaRef3.current;
        el.style.height = "auto"; // resetea para medir bien
        const lineHeight = 20;    // ajusta según tu font-size
        const maxHeight = 5 * lineHeight;

        el.style.height = Math.min(el.scrollHeight, maxHeight) + "px";
    };
    /* important information */
    const textareaRef4 = useRef(null);
    const handleTextAreaInput4 = (e) => {
        const el = textareaRef4.current;
        el.style.height = "auto"; // resetea para medir bien
        const lineHeight = 20;    // ajusta según tu font-size
        const maxHeight = 5 * lineHeight;

        el.style.height = Math.min(el.scrollHeight, maxHeight) + "px";
    };
    /* ideal audience */
    const textareaRef5 = useRef(null);
    const handleTextAreaInput5 = (e) => {
        const el = textareaRef5.current;
        el.style.height = "auto"; // resetea para medir bien
        const lineHeight = 20;    // ajusta según tu font-size
        const maxHeight = 5 * lineHeight;

        el.style.height = Math.min(el.scrollHeight, maxHeight) + "px";
    };

    const handleQuillChange = (name: string, content: string) => {
        if (formik.values[name] !== content) {
            formik.setFieldValue(name, content);
        }
    };

    const getQuillContentLength = (value: unknown) => String(value ?? '').length;

    const handleInviteGuestsChange = (e:any) => {
        const val = e.target.value === 'true';
        formik.setFieldValue("public", val);
        formik.validateForm();
    };

    const handleAdditionalTeamMembersChange = (value:string) => {
        formik.setFieldValue("additional_team_member_ids", value);
        formik.validateForm();
    };

    const handleBeneficiariesChange = (value: number | null) => {
        formik.setFieldValue("payout_method", value);
        formik.validateForm();
    };

    return (
        <div className="tap-add-experience-2-wrapper-container">
            <div className="tap-add-experience-2-wrapper">
                {/* <!-- 1. TITLE --> */}
                <div className="tap-add-experience-2-header">
                    <div className="tap-add-experience-2-title">
                        { formik?.values?.id > 0 ? 'Edit experience' : 'Host Experience' }
                    </div>
                </div>
                {/* <!-- 2. STEP HEADER --> */}
                <div className={`tap-add-experience-2-step-header ${formik?.values?.id > 0 ? 'd-none' : ''}`}>
                    <div className="tap-add-experience-2-step-count">step 2/3</div>
                    <div className="tap-add-experience-2-divider"></div>
                </div>
                <section className={`tap-add-experience-2-section ${formik?.values?.id > 0 ? '' : 'd-none'}`}>
                    <div className="tap-add-experience-2-section-text">
                        NOTE
                    </div>
                    <div className="tap-add-experience-2-input-group">
                        <label className="tap-add-experience-2-label">You can only edit certain info only when editing an active experience</label>
                        <div className="tap-add-experience-2-input-line">
                        </div>
                    </div>
                </section>
                {/* <!-- 5. Host Type --> */}
                <section className={`tap-add-experience-2-section ${isFinalUser || isPartner || isTeamMember ? 'd-none' : 'd-flex'}`}>
                    <label className="tap-add-experience-2-section-heading">Type Host</label>
                    <div className="tap-add-experience-2-radio-row">
                        <div className={`tap-add-experience-2-radio-card w-50 ${formik.values.host_type === "partner" ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100">
                                <input type="radio" className="tap-host-radio-input"
                                    name="host_type"
                                    value="partner"
                                    checked={formik.values.host_type === "partner"}
                                    onChange={formik.handleChange}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">Partner</div>
                            </label>
                        </div>
                        <div className={`tap-add-experience-2-radio-card w-50 ${formik.values.host_type === "member" ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100">
                                <input type="radio" className="tap-host-radio-input"
                                    name="host_type"
                                    value="member"
                                    checked={formik.values.host_type === "member"}
                                    onChange={formik.handleChange}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">Member</div>
                            </label>
                        </div>
                    </div>
                    <ErrorMessage name="host_type" component="div" className="tap-add-experience-text text-danger" />
                </section>
                {/* <!-- 5. Host --> */}
                <section className={`tap-add-experience-2-section ${isFinalUser || isTeamMember ? 'd-none' : ''}`}>
                    <label className="tap-add-experience-2-label">Host</label>
                    <div>
                        <HostsAutocompleteField
                            hosts={listHost ?? []}
                            value={formik.values.host_id}
                            onChange={(id) => formik.setFieldValue('host_id', id)}
                            placeholder="Select a host"
                            disabled={isFinalUser || isTeamMember}
                            hostType={formik.values.host_type}
                        />
                        <div className="tap-add-experience-2-input-hint mt-3">
                            Select the host of the experience
                        </div>
                        <ErrorMessage name="host_id" component="div" className="tap-add-experience-text text-danger" />
                    </div>
                </section>
                {/* <!-- 3. NAME THE EXPERIENCE --> */}
                <section className="tap-add-experience-2-section">
                    <div className="tap-add-experience-2-section-text">
                        Share your best—what’s ordinary to you is extraordinary to others.
                    </div>
                    <div className="tap-add-experience-2-input-group">
                        <label className="tap-add-experience-2-label">name the experience</label>
                        <div className="tap-add-experience-2-input-line">
                            <input className="tap-add-experience-2-input"
                                name="title"
                                value={formik.values.title}
                                onChange={handleExperienceChange}
                                maxLength={100} />
                        </div>
                        <div className="tap-add-experience-2-input-footer">
                            <span className="tap-add-experience-2-input-hint">
                                Give your experience a compelling title
                            </span>
                            <span className="tap-add-experience-2-input-counter">{formik?.values?.title?.length}/100</span>
                        </div>
                        <ErrorMessage name="title" component="div" className="tap-add-experience-text text-danger" />
                    </div>
                </section>
                {/* <!-- 3. description THE EXPERIENCE --> */}
                <section className="tap-add-experience-2-section">
                    <div className="tap-add-experience-2-input-group">
                        <label className="tap-add-experience-2-label">Short description</label>
                        <div className="tap-add-experience-2-input-line">
                            <input className="tap-add-experience-2-input"
                                name="description"
                                value={formik.values.description}
                                onChange={handleDescriptionChange}
                                maxLength={100} />
                        </div>
                        <div className="tap-add-experience-2-input-footer">
                            <span className="tap-add-experience-2-input-hint">
                                Give your experience a compelling description
                            </span>
                            <span className="tap-add-experience-2-input-counter">{formik?.values?.description?.length}/100</span>
                        </div>
                        <ErrorMessage name="description" component="div" className="tap-add-experience-text text-danger" />
                    </div>
                </section>
                {/* <!-- 4. ITINERARY --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-label">Itinerary of Experience</label>
                    <div>
                        <div className="tap-add-experience-2-input-line h-auto">
                            <ReactQuill
                                theme="snow"
                                className="ql-editor-biography w-100"
                                value={formik.values.itinerary}
                                onChange={(content) => handleQuillChange('itinerary', content)}
                            />
                        </div>
                        <div className="tap-add-experience-2-input-hint mt-3">
                            Provide a detailed schedule of your experience, outlined by days, hours, or key moments.
                        </div>
                        <div className="tap-add-experience-2-input-footer">
                            <span className="tap-add-experience-2-input-hint">HTML content limit</span>
                            <span className="tap-add-experience-2-input-counter">{getQuillContentLength(formik.values.itinerary)}/{MAX_QUILL_CONTENT_LENGTH}</span>
                        </div>
                        <ErrorMessage name="itinerary" component="div" className="tap-add-experience-text text-danger" />
                    </div>
                </section>
                {/* <!-- 5. WHAT'S INCLUDED --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-label">What's Included</label>
                    <div>
                        <div className="tap-add-experience-2-input-line h-auto">
                            <ReactQuill
                                theme="snow"
                                className="ql-editor-biography w-100"
                                value={formik.values.what_is_included}
                                onChange={(content) => handleQuillChange('what_is_included', content)}
                            />
                        </div>
                        <div className="tap-add-experience-2-input-hint mt-3">
                            List what is included—meals, transport, access, or other key elements.
                        </div>
                        <div className="tap-add-experience-2-input-footer">
                            <span className="tap-add-experience-2-input-hint">HTML content limit</span>
                            <span className="tap-add-experience-2-input-counter">{getQuillContentLength(formik.values.what_is_included)}/{MAX_QUILL_CONTENT_LENGTH}</span>
                        </div>
                        <ErrorMessage name="what_is_included" component="div" className="tap-add-experience-text text-danger" />
                    </div>
                </section>
                {/* <!-- 6. AVAILABILITY --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Availability </label>
                    <div className="tap-add-experience-2-radio-row">
                        <div className={`tap-add-experience-2-radio-card ${formik.values.availability_type === "by_date" ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100">
                                <input type="radio" className="tap-host-radio-input"
                                    name="availability_type"
                                    value="by_date"
                                    checked={formik.values.availability_type === "by_date"}
                                    onChange={formik.handleChange}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">By Date</div>
                            </label>
                        </div>
                        <div className={`tap-add-experience-2-radio-card ${formik.values.availability_type === "by_request" ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100">
                                <input type="radio" className="tap-host-radio-input"
                                    name="availability_type"
                                    value="by_request"
                                    checked={formik.values.availability_type === "by_request"}
                                    onChange={formik.handleChange}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">Upon Request</div>
                            </label>
                        </div>
                    </div>
                    <div className={`w-100 flex-column ${formik.values.availability_type === "by_date" ? 'd-flex' : 'd-none'}`}>
                        <FieldArray name="dates_data">
                            {({ push, remove }) => (<>
                                <div role="button" onClick={() => push({ start: null, end: null })} className="tap-add-experience-2-add-text mb-5">
                                    + Add a date
                                </div>
                                <div className='d-flex flex-column w-100'>
                                    {(formik.values.dates_data ?? []).map((item, index) => (
                                        <div key={`dates_data-${index}`} className='d-flex flex-column'>
                                            <div className="w-100 d-flex flex-row gap-4" style={{ marginBottom: "24px" }}>
                                                {/* START DATE */}
                                                <DatePicker
                                                    value={item.start ? dayjs(item.start) : null}
                                                    onChange={(value) => formik.setFieldValue(`dates_data[${index}].start`, value ? value.toISOString() : null)}
                                                    showTime={{ format: "HH:mm" }}
                                                    format="D MMM YYYY HH:mm"
                                                    placeholder="Start date"
                                                    disabledDate={(current) => {return current && current <= dayjs().endOf("day");}}
                                                    className="form-control" />
                                                {/* END DATE */}
                                                <DatePicker
                                                    value={item.end ? dayjs(item.end) : null}
                                                    onChange={(value) => formik.setFieldValue(`dates_data[${index}].end`, value ? value.toISOString() : null)}
                                                    showTime={{ format: "HH:mm" }}
                                                    format="D MMM YYYY HH:mm"
                                                    placeholder="End date"
                                                    disabledDate={(current) => {return current && current <= dayjs().endOf("day");}}
                                                    className="form-control" />

                                                {/* REMOVE BUTTON */}
                                                {index >= 0 && (<>
                                                    {/* <button type="button" onClick={() => {}} className="remove-btn tap-flex-center">
                                                        <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_add_experience_availability_date_edit.svg' />&nbsp;
                                                    </button> */}
                                                    <button type="button" onClick={() => remove(index)} className="remove-btn tap-flex-center">
                                                        <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_add_experience_availability_date_delete.svg' />&nbsp;
                                                    </button>
                                                </>)}
                                            </div>
                                            <div className='w-100 d-flex flex-row'>
                                                <ErrorMessage name={`dates_data[${index}].start`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                <ErrorMessage name={`dates_data[${index}].end`} component="div" className="tap-add-experience-text text-danger w-50" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>)}
                        </FieldArray>
                    </div>
                    {/* <ErrorMessage name={`dates_data`} component="div" className="tap-add-experience-text text-danger w-50" /> */}
                    <div className={`w-100 flex-column mt-3 ${formik.values.availability_type === "by_request" ? 'd-flex' : 'd-none'}`}>
                        <span className="tap-add-experience-2-input-hint" style={{ fontSize: '13px', color: '#6c757d', fontStyle: 'normal' }}>
                            For experiences without fixed dates — availability is confirmed directly with the member upon request.
                        </span>
                    </div>
                </section>
                {/* <!-- 7. DURATION --> */}
                <section className={`tap-add-experience-2-section  ${formik.values.availability_type === "by_date" ? 'd-none' : 'd-flex'}`}>
                    <label className="tap-add-experience-2-section-heading">Duration</label>
                    <div className="tap-add-experience-2-duration-box">
                        <div className="tap-add-experience-2-duration-header">
                            <div className="tap-add-experience-2-duration-left w-100">
                                <span>#</span>
                                <input name="duration" type='number' value={formik.values.duration} onChange={formik.handleChange} className="tap-add-experience-2-input" />
                            </div>
                            <div className="tap-add-experience-2-duration-right">
                                {/* <span>Day</span>
                                <div className="tap-add-experience-2-arrow"></div> */}
                                <select name="duration_type" value={formik.values.duration_type} onChange={formik.handleChange} className='tap-select-add-experience' placeholder='Select an option'>
                                    {(catalogs?.durations ?? []).map((r:GenericModel,index)=>
                                        (<option key={`duration-${index}`} value={r.id}>{r.name}</option>)
                                    )}
                                </select>
                            </div>
                        </div>
                        <ErrorMessage name="duration" component="div" className="tap-add-experience-text text-danger" />
                        <ErrorMessage name="duration_type" component="div" className="tap-add-experience-text text-danger" />
                        <div className="tap-add-experience-2-input-hint">
                            Specify how long the experience lasts
                        </div>
                    </div>
                </section>
                {/* <!-- 8. PRICE PER GUEST / GROUP --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">
                        {formik.values.price_type == 2 ? 'Price Per Group' : 'Price Per Guest'}
                    </label>
                    <div className="tap-add-experience-2-description">
                        Set the net price {formik.values.price_type == 2 ? 'per group' : 'per guest'}. A Nobilis platform fee of 15% (non-profit invitations) or 18.5% (for-profit) will be added to the final price
                    </div>

                    <div className="tap-add-experience-2-radio-row mt-4">
                        <div className={`tap-add-experience-2-radio-card ${Number(formik.values.price_type) !== 2 ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100 cursor-pointer">
                                <input type="radio" className="tap-host-radio-input"
                                    name="price_type"
                                    value={1}
                                    checked={Number(formik.values.price_type) !== 2}
                                    onChange={() => formik.setFieldValue('price_type', 1)}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">Per Guest</div>
                            </label>
                        </div>
                        <div className={`tap-add-experience-2-radio-card ${Number(formik.values.price_type) === 2 ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100 cursor-pointer">
                                <input type="radio" className="tap-host-radio-input"
                                    name="price_type"
                                    value={2}
                                    checked={Number(formik.values.price_type) === 2}
                                    onChange={() => formik.setFieldValue('price_type', 2)}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">Per Group</div>
                            </label>
                        </div>
                    </div>
                    <ErrorMessage name="price_type" component="div" className="tap-add-experience-text text-danger" />

                    <div className="tap-add-experience-2-price-box">
                        <div className="tap-add-experience-2-price-left w-100">
                            <span>USD </span>
                            <input name="price_per_guest_text" type='text' value={priceField.value} onFocus={priceField.handleFocus} onChange={priceField.handleChange} onBlur={priceField.handleBlur} className="tap-add-experience-2-input" max={1000000000} maxLength={10} />
                        </div>
                        <div className="tap-add-experience-2-price-right">
                            <span>{formik.values.price_type == 2 ? '/Group' : '/Guest'}</span>
                        </div>
                    </div>
                    <ErrorMessage name="price_per_guest_text" component="div" className="tap-add-experience-text text-danger" />

                    {formik.values.price_type == 2 && (
                        <div className="tap-add-experience-2-duration-box mt-4">
                            <div className="tap-add-experience-2-duration-header">
                                <div className="tap-add-experience-2-duration-left w-100">
                                    <span>#</span>
                                    <input name="max_guests_per_group" type='number' placeholder="Max guests per group" value={formik.values.max_guests_per_group ?? ''} onChange={formik.handleChange} className="tap-add-experience-2-input" min={1} />
                                </div>
                            </div>
                            <ErrorMessage name="max_guests_per_group" component="div" className="tap-add-experience-text text-danger" />
                            <div className="tap-add-experience-2-input-hint">
                                Maximum capacity of guests per group
                            </div>
                        </div>
                    )}
                </section>
                {/* <!-- 9. OPTIONAL ENHANCEMENTS --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">
                        Optional Enhancements ({formik.values.price_type == 2 ? 'Per Group' : 'Per Guest'})
                    </label>
                    <div className="tap-add-experience-2-description">
                        List what is not included by default but can be arranged on request.
                    </div>
                    <div className="tap-add-experience-2-enhancement-row">
                        <div className={`w-100 flex-column`}>
                            <FieldArray name="enhancements_data">
                                {({ push, remove }) => (<>
                                    <div className='d-flex flex-column w-100'>
                                        {formik.values.enhancements_data.map((item, index) => {
                                            return (<div key={`enhancements_data-${index}`} className='d-flex flex-column'>
                                                <div className="w-100 d-flex flex-row gap-4" style={{ marginBottom: "24px" }}>
                                                    {/* START FIELDS */}
                                                    <div className="tap-add-experience-2-enhancement-input">
                                                        <label className="tap-add-experience-2-label">Service Name</label>
                                                        <div className="tap-add-experience-2-input-line">
                                                            <input value={item.name} onChange={(value) => formik.setFieldValue(`enhancements_data[${index}].name`, value.target.value)} className="tap-add-experience-2-input" />
                                                        </div>
                                                    </div>
                                                    <div className="tap-add-experience-2-enhancement-input">
                                                        <label className="tap-add-experience-2-label">Price (USD)</label>
                                                        <div className="tap-add-experience-2-input-line">
                                                            <EnhancementRow key={index} formik={formik} index={index} />
                                                        </div>
                                                    </div>
                                                    {/* REMOVE BUTTON */}
                                                    {index >= 0 && (<>
                                                        {/* <button type="button" onClick={() => {}} className="remove-btn tap-flex-center">
                                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_add_experience_availability_date_edit.svg' />&nbsp;
                                                        </button> */}
                                                        <button type="button" onClick={() => remove(index)} className="remove-btn tap-flex-center">
                                                            <KTSVG path='/media/svg/nobilis/teams_and_partner/team_and_partner_experiences_add_experience_availability_date_delete.svg' />&nbsp;
                                                        </button>
                                                    </>)}
                                                </div>
                                                <div className='w-100 d-flex flex-row'>
                                                    <ErrorMessage name={`enhancements_data[${index}].name`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                    <ErrorMessage name={`enhancements_data[${index}].price`} component="div" className="tap-add-experience-text text-danger w-50" />
                                                </div>
                                            </div>)
                                        })}
                                    </div>
                                    <div role="button" onClick={() => push({ name: '', price: '', price_text: '' })} className="tap-add-experience-2-add-text mb-5">
                                        + Add more
                                    </div>
                                </>)}
                            </FieldArray>
                        </div>
                    </div>
                </section>
                {/* <!-- 10. CATEGORIES --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Categories</label>
                    <div className="tap-add-experience-2-description">Select up to 3 applicable categories:</div>
                    <div className="tap-add-experience-2-category-row">
                        {/* aqui debe de ser un componente tipo selector creo hay que ver como esta el de editar el profile */}
                        <CategoryAutocompleteField values={formik.values.category_ids} onChange={handleCategoryChange}/>
                    </div>
                    <ErrorMessage name={`category_ids`} component="div" className="tap-add-experience-text text-danger w-50" />
                </section>
                {/* <!-- 11. LOCATION --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Location</label>
                    <div className="tap-add-experience-2-description">
                        Only confirmed guests will see the full address. Until then, only city and country.
                    </div>
                    <div className="tap-add-experience-2-input-group">
                        <label className="tap-add-experience-2-label">City</label>
                        <CityAutocompleteField name='city' />
                        <ErrorMessage name={`city`} component="div" className="tap-add-experience-text text-danger" />
                    </div>
                    <div className="tap-add-experience-2-input-group">
                        <label className="tap-add-experience-2-label">Address</label>
                        <div className="tap-add-experience-2-input-line">
                            <input name="location_address" value={formik.values.location_address} onChange={formik.handleChange} className="tap-add-experience-2-input" />
                        </div>
                        <ErrorMessage name={`location_address`} component="div" className="tap-add-experience-text text-danger" />
                    </div>
                    <div className="tap-add-experience-2-input-group">
                        <label className="tap-add-experience-2-label">Arrival notes</label>
                        <div className="tap-add-experience-2-input-line h-auto">
                            <textarea name="arrival_notes" value={formik.values.arrival_notes} onChange={formik.handleChange} className="tap-add-experience-2-input textarea-autosize" onInput={handleTextAreaInput3} ref={textareaRef3} maxLength={10000} />
                        </div>
                        <ErrorMessage name={`arrival_notes`} component="div" className="tap-add-experience-text text-danger" />
                    </div>
                </section>
                {/* <!-- 12. INVITE GUESTS --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Invite Guests</label>
                    <div className="tap-add-experience-2-description">
                        You may share your experience openly with all Members - Public, or keep it Private—inviting only selected Members of the Nobilis community.
                    </div>
                    <div className="tap-add-experience-2-radio-list">
                        <div className={`tap-add-experience-2-radio-card ${formik.values.public ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100">
                                <input
                                    type="radio"
                                    name="public"
                                    value={true}
                                    className="tap-host-radio-input"
                                    checked={formik.values.public}
                                    onChange={handleInviteGuestsChange}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">Public - Visible to all Nobilis Members</div>
                            </label>
                        </div>
                        <div className={`tap-add-experience-2-radio-card ${!formik.values.public ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100">
                                <input disabled={false/* userData?.subscription?.plan?.title?.toLowerCase() !== SubscriptionEnum.ElectiPlus.toLowerCase() */}
                                    type="radio"
                                    name="public"
                                    value={false}
                                    className={`tap-host-radio-input`}
                                    checked={!formik.values.public}
                                    onChange={handleInviteGuestsChange}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className={`tap-host-option-label ${userData?.subscription?.plan?.title?.toLowerCase() !== SubscriptionEnum.ElectiPlus.toLowerCase() ? 'w-50' : 'w-100'}`}>
                                    Private — Accessible Only to Those You Invite
                                </div>
                                {userData?.subscription?.plan?.title?.toLowerCase() !== SubscriptionEnum.ElectiPlus.toLowerCase() ? (
                                    <Link to="/membership/change" className="tap-add-experience-2-upgrade-container w-50">
                                        <div className="tap-add-experience-2-upgrade-text-group">
                                            <div className="tap-add-experience-2-upgrade-title">
                                            Upgrade to host private encounter
                                            </div>
                                            <div className="tap-add-experience-2-upgrade-subtitle">
                                            {SubscriptionEnum.ElectiPlus} Membership Required
                                            </div>
                                        </div>
                                        &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                                    </Link>

                                ) : null}
                            </label>
                        </div>
                    </div>
                    <div className={`w-100 flex-column ${!formik.values.public ? 'd-flex' : 'd-none'}`}>
                        <label className="tap-add-experience-2-label">list and Select invitees</label>
                        <InviteePrivateAutocompleteField values={formik.values.allowed_guest_ids} onChange={handleInviteesChange} initialSelected={experience?.allowedGuestsDetails}/>
                    </div>
                    <ErrorMessage name={`allowed_guest_ids`} component="div" className={`tap-add-experience-text text-danger ${!formik.values.public ? 'd-flex' : 'd-flex'}`} />
                </section>
                {/* <!-- 13. AUDIENCE --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Audience</label>
                    <div className="tap-add-experience-2-radio-row">
                        {(catalogs?.audiences ?? []).map((audience:GenericModel,index)=>{
                            return (<div key={`radio-audience-${index}`} className={`tap-add-experience-2-radio-card ${formik.values.audience_type == audience.id ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                                <label className="tap-host-option p-6 w-100">
                                    <input
                                        type="radio"
                                        name="audience_type"
                                        value={audience.id}
                                        className="tap-host-radio-input"
                                        checked={formik.values.audience_type == audience.id}
                                        onChange={(e) => {
                                            formik.handleChange(e);
                                            if (Number(audience.id) === 2 || String(audience.id) === '2') {
                                                formik.setFieldValue('guest_capacity_children', '');
                                                formik.setFieldValue('guest_capacity_youth', '');
                                                formik.setFieldValue('guest_capacity_infants', '');
                                            }
                                        }}
                                        onBlur={formik.handleBlur}/>
                                    <div className="tap-host-radio">
                                        <div className="tap-host-radio-outer"></div>
                                        <div className="tap-host-radio-inner"></div>
                                    </div>
                                    <div className="tap-host-option-label">{audience.name}</div>
                                </label>
                            </div>)
                        })}
                    </div>
                    <div className="tap-add-experience-2-description">
                        Infants (under 2 years) are free of charge.
                    </div>
                </section>
                {/* <!-- 13b. TOTAL GUESTS (UAT-212 P1) --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Total Guests</label>
                    <div className="tap-add-experience-2-capacity-row">
                        <div className="tap-add-experience-2-capacity-col d-flex">
                            <label className="tap-add-experience-2-label">Minimum Guests</label>
                            <div className="tap-add-experience-2-input-line">
                                <input type='text' inputMode='numeric' name="total_min_guests" value={formik.values.total_min_guests ?? ''} onChange={(e)=>formik.setFieldValue('total_min_guests', e.target.value.replace(/[^0-9]/g, ''))} className="tap-add-experience-2-input" placeholder='Minimum' />
                            </div>
                            <ErrorMessage name={`total_min_guests`} component="div" className="tap-add-experience-text text-danger" />
                        </div>
                        <div className="tap-add-experience-2-capacity-col d-flex">
                            <label className="tap-add-experience-2-label">Maximum Guests</label>
                            <div className="tap-add-experience-2-input-line">
                                <input type='text' inputMode='numeric' name="total_max_guests" value={formik.values.total_max_guests ?? ''} onChange={(e)=>formik.setFieldValue('total_max_guests', e.target.value.replace(/[^0-9]/g, ''))} className="tap-add-experience-2-input" placeholder='Maximum' />
                            </div>
                            <ErrorMessage name={`total_max_guests`} component="div" className="tap-add-experience-text text-danger" />
                        </div>
                    </div>
                </section>
                {/* <!-- 14. GUEST CAPACITY --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Guest Capacity</label>
                    <div className="tap-add-experience-2-capacity-row">
                        <div className={`tap-add-experience-2-capacity-col ${formik.values.audience_type == 1 || formik.values.audience_type == 2 ? 'd-flex' : 'd-none' }`}>
                            <label className="tap-add-experience-2-label">Adults</label>
                            <div className="tap-add-experience-2-input-line">
                                <input type='text' name="guest_capacity_adults" value={formik.values.guest_capacity_adults} onChange={formik.handleChange} className="tap-add-experience-2-input" placeholder='Minimun - Maximun' />
                            </div>
                            <div className="tap-add-experience-2-input-hint">Ages 13 or above</div>
                            <ErrorMessage name={`guest_capacity_adults`} component="div" className="tap-add-experience-text text-danger" />
                        </div>
                        <div className={`tap-add-experience-2-capacity-col ${formik.values.audience_type == 1 ? 'd-flex' : 'd-none' }`}>
                            <label className="tap-add-experience-2-label">Youth</label>
                            <div className="tap-add-experience-2-input-line">
                                <input type='text' name="guest_capacity_youth" value={formik.values.guest_capacity_youth} onChange={formik.handleChange} className="tap-add-experience-2-input" placeholder='Minimun - Maximun' />
                            </div>
                            <div className="tap-add-experience-2-input-hint">Ages 13-17</div>
                            <ErrorMessage name={`guest_capacity_youth`} component="div" className="tap-add-experience-text text-danger" />
                        </div>
                        <div className={`tap-add-experience-2-capacity-col ${formik.values.audience_type == 1 ? 'd-flex' : 'd-none' }`}>
                            <label className="tap-add-experience-2-label">Children</label>
                            <div className="tap-add-experience-2-input-line">
                                <input type='text' name="guest_capacity_children" value={formik.values.guest_capacity_children} onChange={formik.handleChange} className="tap-add-experience-2-input" placeholder='Minimun - Maximun' />
                            </div>
                            <div className="tap-add-experience-2-input-hint">Ages 2-12</div>
                            <ErrorMessage name={`guest_capacity_children`} component="div" className="tap-add-experience-text text-danger" />
                        </div>
                        <div className={`tap-add-experience-2-capacity-col ${formik.values.audience_type == 1 ? 'd-flex' : 'd-none' }`}>
                            <label className="tap-add-experience-2-label">Infants</label>
                            <div className="tap-add-experience-2-input-line">
                                <input type='text' name="guest_capacity_infants" value={formik.values.guest_capacity_infants} onChange={formik.handleChange} className="tap-add-experience-2-input" placeholder='Minimun - Maximun' />
                            </div>
                            <div className="tap-add-experience-2-input-hint">Under 2</div>
                            <ErrorMessage name={`guest_capacity_infants`} component="div" className="tap-add-experience-text text-danger" />
                        </div>
                    </div>
                </section>
                {/* <!-- 15. IMPORTANT INFORMATION --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Important Information for Guests <span className='tap-add-experience-guest-option'>(OPTIONAL)</span></label>
                    <div className="tap-add-experience-2-description">
                        Share important details or instructions guests should know.
                    </div>
                    <div>
                        <div className="tap-add-experience-2-input-line h-auto">
                            <ReactQuill
                                theme="snow"
                                className="ql-editor-biography w-100"
                                value={formik.values.important_information_guest}
                                onChange={(content) => handleQuillChange('important_information_guest', content)}
                            />
                        </div>
                        <div className="tap-add-experience-2-input-hint mt-3">E.g., Clothing, gear, fitness level, cultural context, or anything guests should know</div>
                        <div className="tap-add-experience-2-input-footer">
                            <span className="tap-add-experience-2-input-hint">HTML content limit</span>
                            <span className="tap-add-experience-2-input-counter">{getQuillContentLength(formik.values.important_information_guest)}/{MAX_QUILL_CONTENT_LENGTH}</span>
                        </div>
                        <ErrorMessage name={`important_information_guest`} component="div" className="tap-add-experience-text text-danger" />
                    </div>
                </section>
                {/* <!-- 16. IDEAL AUDIENCE --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Ideal Audience <span className='tap-add-experience-guest-option'>(OPTIONAL)</span></label>
                    <div className="tap-add-experience-2-input-group">
                        <label className="tap-add-experience-2-label">Who is this experience designed for?</label>
                        <div className="tap-add-experience-2-input-line h-auto">
                            <ReactQuill
                                theme="snow"
                                className="ql-editor-biography w-100"
                                value={formik.values.ideal_audience}
                                onChange={(content) => handleQuillChange('ideal_audience', content)}
                            />
                        </div>
                        <div className="tap-add-experience-2-input-hint">E.g., Adventurers, collectors, philanthropists, families</div>
                        <div className="tap-add-experience-2-input-footer">
                            <span className="tap-add-experience-2-input-hint">HTML content limit</span>
                            <span className="tap-add-experience-2-input-counter">{getQuillContentLength(formik.values.ideal_audience)}/{MAX_QUILL_CONTENT_LENGTH}</span>
                        </div>
                        <ErrorMessage name={`ideal_audience`} component="div" className="tap-add-experience-text text-danger" />
                    </div>
                </section>
                {/* <!-- 17. HOST PRESENCE --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Host Presence & Team Management</label>
                    <div className="tap-add-experience-2-label">
                        Specify your personal participation—experiences require significant host presence to be accepted.
                    </div>
                    <div>
                        <div className="tap-add-experience-2-input-line">
                            <input name="host_presence" value={formik.values.host_presence} onChange={formik.handleChange} className="tap-add-experience-2-input" maxLength={100} />
                        </div>
                        <div className="tap-add-experience-2-input-hint mt-3">
                            E.g. Full duration, Opening Dinner (min. 3 hours), or Final Day
                        </div>
                        <ErrorMessage name={`host_presence`} component="div" className="tap-add-experience-text text-danger" />
                    </div>
                    {/* <div className="tap-add-experience-2-label">
                        Assign additional team members or representatives to support your experience (optional).
                    </div>
                    <div>
                        <div className={`w-100 flex-column`}>
                            <MembersHostPresenceAutocompleteField values={formik.values.additional_team_member_ids} onChange={handleAdditionalTeamMembersChange}/>
                        </div>
                        <ErrorMessage name={`additional_team_member_ids`} component="div" className={`tap-add-experience-text text-danger`} />
                    </div> */}
                </section>
                {/* <!-- 18. BENEFICIARY --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Beneficiary</label>
                    <div className='tap-add-experience-2-section-beneficiary-description'>Select the type of beneficiary for this experience. Non-Profit beneficiaries will be displayed publicly as Impact/Philanthropy; For-Profit beneficiaries remain private.</div>
                    <div className="tap-add-experience-2-radio-row">
                        <div className={`tap-add-experience-2-radio-card ${formik.values.beneficiary_for_profit ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100">
                                <input
                                    type="radio"
                                    name="beneficiary_for_profit"
                                    className="tap-host-radio-input"
                                    checked={formik.values.beneficiary_for_profit === true}
                                    onChange={() => {
                                        formik.setFieldValue("beneficiary_for_profit", true);
                                        formik.setFieldValue("payout_method", null);
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">For-Profit</div>
                            </label>
                        </div>
                        <div className={`tap-add-experience-2-radio-card ${!formik.values.beneficiary_for_profit ? 'tap-add-experience-2-radio-card--selected' : ''}`}>
                            <label className="tap-host-option p-6 w-100">
                                <input
                                    type="radio"
                                    name="beneficiary_for_profit"
                                    className="tap-host-radio-input"
                                    checked={formik.values.beneficiary_for_profit === false}
                                    onChange={() => {
                                        formik.setFieldValue("beneficiary_for_profit", false);
                                        formik.setFieldValue("payout_method", null);
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                                <div className="tap-host-radio">
                                    <div className="tap-host-radio-outer"></div>
                                    <div className="tap-host-radio-inner"></div>
                                </div>
                                <div className="tap-host-option-label">Non-Profit (Impact/Philanthropy)</div>
                            </label>
                        </div>
                    </div>
                    <div className={`tap-add-experience-2-checkbox-row ${!formik.values.beneficiary_for_profit ? 'd-flex' : 'd-none'}`}>
                        <div className="w-100 d-flex flex-column">
                            <div className="pf-checkbox mb-2 tap-flex-center">
                                <input id="beneficiary_check" className="pf-check mt-1" name='beneficiary_check' checked={formik.values.beneficiary_check} onChange={formik.handleChange} onBlur={formik.handleBlur} type="checkbox" />
                                <label htmlFor="beneficiary_check" className="tap-add-experience-2-checkbox-text">
                                    I acknowledge that if this experience is marked as Non-Profit, the selected account name
                                    will be publicly displayed as the beneficiary.
                                </label>
                            </div>
                        </div>
                    </div>
                    <ErrorMessage name={`beneficiary_check`} component="div" className={`tap-add-experience-text text-danger`} />
                    <div className="tap-add-experience-2-label">
                        Select beneficiary
                    </div>
                    <div className={`w-100 flex-column`}>
                        <BeneficiaryAutocompleteField profit={formik.values.beneficiary_for_profit} isAdmin={userData.user?.role === UserRole.ADMIN} host={formik.values.host_id} values={formik.values.payout_method} onChange={handleBeneficiariesChange}/>
                    </div>
                    <ErrorMessage name={`payout_method`} component="div" className={`tap-add-experience-text text-danger`} />
                </section>
                {/* <!-- 19. VISUALS --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Visuals</label>
                    <div className="tap-add-experience-2-description">
                        Select images that reflect the tone, setting, and uniqueness of your experience. The first image will serve as the cover.
                    </div>
                    <div className="tap-add-experience-2-upload-box">
                        <label>Cover Images</label>
                    </div>
                    <div className="tap-add-experience-2-upload-box">
                        <ImageExperienceField />
                        <ErrorMessage name={`imageCover`} component="div" className={`tap-add-experience-text text-danger`} />
                    </div>
                    <div className="tap-add-experience-2-upload-box">
                        <label>Gallery Images</label>
                    </div>
                    <div className="tap-add-experience-2-upload-box">
                        <GalleryUploadField />
                        <div className="tap-add-experience-2-input-hint mt-3">
                            Click and drag the images to arrange them in your preferred order.
                        </div>
                        <ErrorMessage name={`galleryImages`} component="div" className={`tap-add-experience-text text-danger`} />
                    </div>
                </section>
                {/* <!-- 20. VIDEO LINK --> */}
                <section className="tap-add-experience-2-section">
                    <label className="tap-add-experience-2-section-heading">Add Video Link <span className='tap-add-experience-guest-option'>(OPTIONAL)</span></label>
                    <div className="tap-add-experience-2-input-line">
                        <input name="optional_video_link" value={formik.values.optional_video_link} onChange={formik.handleChange} className="tap-add-experience-2-input" />
                    </div>
                    <ErrorMessage name={`optional_video_link`} component="div" className={`tap-add-experience-text text-danger`} />
                </section>
                {/* <!-- 21. FOOTER --> */}
                <div className="tap-add-experience-2-footer">
                    <div role='button' onClick={()=>history.goBack()} className={`tap-add-experience-2-btn-secondary ${formik.values?.id > 0 ? '' : 'd-none'}`}>
                        go back
                    </div>
                    <div role='button' onClick={onBackStep} className={`tap-add-experience-2-btn-secondary ${formik.values?.id > 0 ? 'd-none' : ''}`}>
                        back
                    </div>
                    <div className="tap-add-experience-2-footer-right">
                        {formik?.values?.id > 0 && (<button type="button" className={`tap-add-experience-2-btn-secondary ${validateShowButtonActions('paused',formik)}`} onClick={()=>onPause(true)}>
                            <div>Pause Experience</div>
                        </button>)}
                        <button type="button" className={`tap-add-experience-2-btn-secondary ${validateShowButtonActions('draft',formik)}`} onClick={onSaveDraft}>
                            <div>save for later</div>
                        </button>
                        <div role='button' onClick={onNextStep} className="tap-add-experience-2-btn-main tap-flex-center">
                            <div className='tap-host-button-text tap-flex-center'>
                                next
                                &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const EnhancementRow = ({ formik, index }) => {
  const priceField = useCurrencyField({
    formik,
    fieldText: `enhancements_data[${index}].price_text`,
    fieldNumber: `enhancements_data[${index}].price`,
  });

  return (
    <input name={`enhancements_data[${index}].price_text`} value={priceField.value} onChange={priceField.handleChange} onFocus={priceField.handleFocus} onBlur={priceField.handleBlur} className="tap-add-experience-2-input" />
  );
};

export { Step2 }
